module.exports = __webpack_public_path__ + "img/Invoice.10040cc4.svg";